import React from 'react';
import Download from 'components/download';
import constants from '../constants';

// Images
import forecastImage from 'images/forecast/Forecasting_Beijing01.jpg';

const ForecastDescriptionPage = () => (
  <div className="container">
    <div className="l-demo-content">
      <div className="tab-content-description">
        <div className="row justify-content-md-center">
          <div className="col-md-10">
            <div className="summary">
              <p>
                Our forecasting system improves the existing air quality forecasts considerably by using an ensemble of models and up-to-date emission inventories based on satellite observations.  We demonstrate the resulting air quality information by running models on both regional and urban scale.
              </p>
              <p>
                Air pollution has become a serious issue to face globally. Up-to-date regional air pollution information and means for emission control of the main pollutants are becoming more and more important.
              </p>
              <p>
                The AirQast forecasting system works on emission estimates from space and the refinement of these emission estimates by spatial downscaling and by source sector apportionment. A wide range of data is used from various satellite instruments. From these satellite data, emission estimates are made for anthropogenic and biogenic sources. With various state-of-the-art techniques, up-to-date emission inventories can be created. By combining these emission data with known information from the ground, a new emission database can be constructed.
              </p>
            </div>
          </div>
          <div className="col-md-12">
            <div className="characteristics-table">
              <div className="col-md-12">
                <div className="main-characteristics">
                  Main characteristics
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="table-item">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="table-label">
                          Air pollutants
                        </div>
                      </div>
                      <div className="col-md-8">
                        <div className="table-value">
                          PM2.5, PM10, NO2, O3, in units µg/m³.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-item">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="table-label">
                          Spatial Resolution
                        </div>
                      </div>
                      <div className="col-md-8">
                        <div className="table-value">
                          <div className="value-list">
                            <ul>
                              <li>
                                The forecasted values therefore represent local (e.g. urban) background values.
                              </li>
                              <li>
                                They do not contain information on neighborhood scale or smaller.
                              </li>
                              <li>
                                25 km resolution, representing local (e.g. urban) background values.
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-item">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="table-label">
                          Temporal Range
                        </div>
                      </div>
                      <div className="col-md-8">
                        <div className="table-value">
                          <div className="value-list">
                            <ul>
                              <li>
                                The time series span 4x24 hours, starting at 00:00 local time, containing yesterday’s analysis, today’s, and following 48h forecast.
                              </li>
                              <li>
                                Daily updated time series, containing yesterday’s analysis, today’s nowcast, and a 2-day forecast.
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-item">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="table-label">
                          Temporal Resolution
                        </div>
                      </div>
                      <div className="col-md-8">
                        <div className="table-value">
                          1 hour.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-item">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="table-label">
                          Update frequency
                        </div>
                      </div>
                      <div className="col-md-8">
                        <div className="table-value">
                          Daily (or every time when new model data is processed).
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-10">
            <div className="demo-image">
              <img src={forecastImage} alt="forecast demo" />
            </div>
          </div>
          <div className="col-md-10">
            <div className="main-1">
              Air pollution has become a serious issue to face globally. Up-to-date regional air pollution information and means for emission control of the main pollutants are becoming more and more important.
            </div>
            <div className="main-2">
              The AirQast forecasting system works on emission estimates from space and the refinement of these emission estimates by spatial downscaling and by source sector apportionment. A wide range of data is used from various satellite instruments. From these satellite data, emission estimates are made for anthropogenic and biogenic sources. With various state-of-the-art techniques, up-to-date emission inventories can be created. By combining these emission data with known information from the ground, a new emission database can be constructed.
            </div>
          </div>
          <Download pdf={constants.forecast.factsheet} />
        </div>
      </div>
    </div>
  </div>

);

export default ForecastDescriptionPage;



// WEBPACK FOOTER //
// ./src/pages/products/forecast/description.js